module.exports = __webpack_public_path__ + "img/dollar.d2bac770.png";